.sellalong-help-modal {
  /* This way it could be display flex or grid or whatever also. */
  display: block;

  /* Probably need media queries here */
  width: 820px;
  max-width: 100%;

  height: 640px;
  max-height: 100%;

  position: fixed;

  z-index: 10001;

  left: 50%;
  top: 50%;

  /* Use this for centering if unknown width/height */
  transform: translate(-50%, -50%);

  /* If known, negative margins are probably better (less chance of blurry text). */
  /* margin: -200px 0 0 -200px; */

  background: white;
  box-shadow: 0 0 40px 5px rgba(0, 0, 0, 0.7);
  transition: visibility 0s linear 0s, opacity 0.3s;
  opacity: 1;
  visibility: visible;
}

.sellalong-help-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;

  background: rgba(0, 0, 0, 0.6);
  transition: visibility 0s linear 0s, opacity 0.3s;
  opacity: 1;
}

.sellalong-help-modal-closed {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0.3s, opacity 0.3s;
}

.sellalong-help-modal > section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sellalong-help-modal .sellalong-help-modal-close-button {
  align-items: center;
  border: 0;
  color: #000;
  display: flex;
  height: 24px;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  right: 20px;
  text-decoration: none;
  top: 20px;
  transition: color 0.1s, background-color 0.1s, border-color 0.1s;
  width: 24px;
  z-index: 1;
  box-sizing: border-box;
}

.sellalong-help-modal-heading {
  color: #000;
  font-family: var(--sellalong-heading-font, serif);
  font-size: var(--sellalong-heading-font-size, 32px);
  font-weight: var(--sellalong-heading-font-weight, normal);
  margin: 40px 0 20px;
  text-align: center;
}

.sellalong-help-modal p {
  font-family: sans-serif;
  font-size: 16px;
  text-align: center;
  margin: 0 0 2em;
  line-height: 1.5em;
  max-width: 540px;
}

.sellalong-help-modal .sellalong-help-modal-nowrap {
  white-space: nowrap;
}

.sellalong-help-modal-steps {
  display: flex;
  margin: 0;
  padding: 0;
  flex: 1;
}

.sellalong-help-modal-steps > li {
  display: block;
  flex: 1;
}
.sellalong-help-modal-steps h4 {
  font-family: var(--sellalong-heading-font, serif);
  font-size: 18px;
  font-weight: normal;
  margin: 24px 0;
  min-height: 2.6em;
}

.sellalong-help-modal-steps figure {
  margin: 0;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  text-align: center;
}

.sellalong-help-modal-steps p {
  font-size: 14px;
  margin: 0 0 1em;
  line-height: 1.2em;
}

.sellalong-help-modal-icon-wrapper {
  background: var(--sellalong-colour-primary, #fff);
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.2);
  width: 140px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sellalong-help-modal-icon-wrapper svg {
  height: auto;
  width: auto;
}

.sellalong-help-modal-icon-wrapper svg g {
  fill: none;
}

.sellalong-help-modal-hint {
  color: #898989;
  font-size: 12px;
}

@media screen and (max-width: 600px) {
  .sellalong-help-modal .sellalong-help-modal-close-button {
    top: 10px;
    right: 10px;
  }
  .sellalong-help-modal > section {
    padding: 16px;
  }

  .sellalong-help-modal-heading {
    font-size: 24px;
    margin-top: 10px;
  }

  .sellalong-help-modal p {
    font-size: 14px;
    margin: 0 0 16px;
  }

  .sellalong-help-modal-steps h4 {
    font-size: 16px;
    min-height: 3.9em;
    margin: 16px 0;
  }

  .sellalong-help-modal-steps p {
    font-size: 12px;
  }

  .sellalong-help-modal-icon-wrapper {
    height: 100px;
    width: 100px;
  }
}
